export default __webpack_public_path__ + "static/media/icon-arrow.2bf6d7a7.svg";